import { render, staticRenderFns } from "./WODetailColor.vue?vue&type=template&id=07faddec&scoped=true"
import script from "./WODetailColor.vue?vue&type=script&lang=js"
export * from "./WODetailColor.vue?vue&type=script&lang=js"
import style0 from "./WODetailColor.vue?vue&type=style&index=0&id=07faddec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07faddec",
  null
  
)

export default component.exports